// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-container[data-v-2110aa12]{margin-top:1.5rem;display:flex;flex-direction:column}.check-input .label[data-v-2110aa12]{font-size:1rem}.filter-title[data-v-2110aa12]{margin-top:0;margin-bottom:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
